import { render, staticRenderFns } from "./GeospatialAnalysis.vue?vue&type=template&id=e99a15b0&scoped=true&"
import script from "./GeospatialAnalysis.vue?vue&type=script&lang=js&"
export * from "./GeospatialAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99a15b0",
  null
  
)

export default component.exports